import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useAdminStore } from '@/store/admin'
import { handleMock, isMockEnabled } from './mock'

// 创建axios实例
const request = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 开启 Mock 时，注入自定义 adapter
if (isMockEnabled()) {
  request.defaults.adapter = async (config) => {
    // 仅拦截以 /admin 开头的接口，其他如外部文件下载可继续默认
    if (typeof config.url === 'string' && config.url.startsWith('/admin')) {
      return handleMock(config)
    }
    // 兜底：走默认 XHR adapter
    const adapter = axios.defaults.adapter
    return adapter(config)
  }
}

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 添加认证token
    const adminStore = useAdminStore()
    if (adminStore.token) {
      config.headers.Authorization = `Bearer ${adminStore.token}`
    }
    
    return config
  },
  (error) => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const { data } = response
    
    // 如果是文件下载，直接返回
    if (response.config.responseType === 'blob') {
      return response
    }
    
    // 统一处理响应数据
    if (data.success === false) {
      ElMessage.error(data.message || '请求失败')
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    
    return data
  },
  (error) => {
    console.error('响应错误:', error)
    
    const { response } = error
    const adminStore = useAdminStore()
    
    if (response) {
      const { status, data } = response
      
      switch (status) {
        case 401:
          // 避免重复处理401错误 - 实现单例提示
          if (!window._adminAuthErrorShown) {
            window._adminAuthErrorShown = true;
            ElMessage.error('登录已过期，请重新登录')
            adminStore.logout()
            window.location.href = '/login'
            // 2秒后允许再次弹出错误提示
            setTimeout(() => {
              window._adminAuthErrorShown = false;
            }, 2000);
          }
          break
        case 403:
          ElMessage.error('没有权限访问该资源')
          break
        case 404:
          ElMessage.error('请求的资源不存在')
          break
        case 500:
          ElMessage.error('服务器内部错误')
          break
        default:
          ElMessage.error(data?.message || `请求失败 (${status})`)
      }
    } else if (error.code === 'ECONNABORTED') {
      ElMessage.error('请求超时，请稍后重试')
    } else if (error.message === 'Network Error') {
      ElMessage.error('网络连接失败，请检查网络')
    } else {
      ElMessage.error(error.message || '未知错误')
    }
    
    return Promise.reject(error)
  }
)

export default request 